
export class VenueEntity {

    public static fromDto(dto: any): VenueEntity {
        if (!dto) {
            return new VenueEntity();
        }
        const entity = new VenueEntity();
        entity.id = dto.id;
        entity.eventId = dto.eventId;
        entity.name = dto.name;
        entity.concurrency = dto.concurrency;

        return entity;
    }

    public static fromDtoArray(dtoArray: any[]): VenueEntity[] {
        const entities: VenueEntity[] = [];
        if (!dtoArray) {
            return entities;
        }
        for (const dto of dtoArray) {
            const entity = VenueEntity.fromDto(dto);
            entities.push(entity);
        }
        return entities;
    }

    public static toDtoArray(entityArray: VenueEntity[]): any[] {
        const dtos = [];
        for (const entity of entityArray) {
            dtos.push(entity.toDto());
        }
        return dtos;
    }
    public id: string = null;
    public eventId: string = null;
    public name: string = null;
    public concurrency: string = null;

    public toDto(): any {
        return {
            id: this.id,
            eventId: this.eventId,
            name: this.name,
            concurrency: this.concurrency
        };
    }
}
